import "./players.css";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../../components/loader/Loader";

interface Player {
  _id: string;
  avatar: string;
  name: string;
  posts: number;
}
export const Players = () => {
  const [players, setPlayers] = useState<Player[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userRoles, setUserRoles] = useState<{ [key: string]: string }>({});
  const [userRole, setUserRole] = useState<string>(() => {
    const userId = localStorage.getItem("userId");
    return userId === "66eabacdd3b1319f548e7dbd" ? "admin" : "";
  });

  const handleDelete = async (userId: string) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/users/${userId}`);
      setPlayers(players.filter((player) => player._id !== userId));
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const userId = localStorage.getItem("userId");
        setUserRole(userId === "66eabacdd3b1319f548e7dbd" ? "admin" : "");

        const response = await axios.get<Player[]>(
          `${process.env.REACT_APP_BASE_URL}/users`
        );
        setPlayers(response.data);

        const rolePromises = response.data.map(async (player) => {
          const roleResponse = await axios.get<string>(
            `${process.env.REACT_APP_BASE_URL}/users/${player._id}/role`
          );
          return { _id: player._id, role: roleResponse.data };
        });

        const roles = await Promise.all(rolePromises);
        const roleMap = roles.reduce<{ [key: string]: string }>(
          (acc, { _id, role }) => {
            acc[_id] = role;
            return acc;
          },
          {}
        );

        setUserRoles(roleMap);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {}, [userRole]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="players">
      <iframe
        style={{
          background: "#21313",
          border: "none",
          borderRadius: "2px",
          boxShadow: "0 2px 10px 0 rgba(70, 76, 79, .2)",
          width: "100vw",
          height: "10rem",
        }}
        src="https://charts.mongodb.com/charts-survivalinteractive-pvbpfhw/embed/charts?id=1f9c0c33-5a1a-4000-bc7b-ba74d70cd1b6&maxDataAge=14400&theme=light&autoRefresh=true"
        title="MongoDB Dashboard"
        frameBorder="0"
        allowFullScreen
      ></iframe>

      <hr></hr>

      {players.length > 0 ? (
        <div className="container players__container">
          {players.map((player) => {
            const { _id, avatar, name, posts } = player;
            const role = userRoles[_id];
            const hasFiveOrMorePosts = posts >= 5;

            return (
              <div
                key={_id}
                className={`player ${
                  hasFiveOrMorePosts ? "has-five-posts" : ""
                }`}
              >
                <Link to={`/posts/users/${_id}`} className="player__link">
                  <div className="player__avatar">
                    <img src={avatar} alt={`Image of ${name}`} />
                  </div>
                  <div className="player__info">
                    <h4>{name}</h4>
                    <p>
                      <strong>Contribution:</strong> {posts}
                    </p>
                  </div>
                </Link>

                {userRole === "admin" && role !== "admin" && (
                  <button
                    className="btn danger"
                    onClick={() => handleDelete(_id)}
                  >
                    Delete user
                  </button>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <h2 className="center">No Users/Players Found</h2>
      )}
    </section>
  );
};
